import SignUpComp from 'src/components/auth/SignUpComp';
import Footer from 'src/components/common/Footer';
import Header from 'src/components/common/Header';

export default function SignUpPage() {
  return (
    <div>
      <Header />
      <SignUpComp />
      <Footer />
    </div>
  );
}
